import type { ReducedPriceProperties } from "@circle-react/types/PaywallCustomization";

interface UseGetReducedPriceProps {
  priceId: number;
  reducedPriceProperties?: ReducedPriceProperties;
  tempId?: string | number;
}

interface FindReducedPriceProps {
  priceId?: string | number;
  prices?: ReducedPriceProperties["prices"];
  tempId?: string | number;
}

const findReducedPrice = ({ prices, priceId, tempId }: FindReducedPriceProps) =>
  prices?.find(price => [priceId, tempId].includes(price.price_id));

export const useGetReducedPrice = ({
  priceId,
  reducedPriceProperties,
  tempId,
}: UseGetReducedPriceProps) =>
  findReducedPrice({ priceId, tempId, prices: reducedPriceProperties?.prices });
